<template>
  <div>
    <div class="kqf-card mg10 search-box mt20">
      <el-form
        :inline="true"
        :model="search"
        size="mini"
        class="demo-form-inline"
      >
        <el-col :span="24">
          <el-form-item label="流水类型">
            <el-radio-group v-model="search.flow_type" @input="getList(1)">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">积分收入</el-radio>
              <el-radio :label="2">积分支出</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="支出/收入类型" class="ml20">
            <el-radio-group v-model="search.type" @input="getList(1)">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">关注公众号</el-radio>
              <el-radio :label="2">邀请好友</el-radio>
              <el-radio :label="4">兑换查询余额</el-radio>
              <el-radio :label="5">同步报价单积分</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <div class="line-dashed mb10"></div>
        </el-col>

        <el-form-item label="关键字：">
          <el-input
            v-model="search.keyword"
            placeholder="请输入昵称或手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="流水时间">
          <el-date-picker
            v-model="search.create_time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList(1)">查询</el-button>
          <el-button @click="refresh">重置</el-button>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            总赠送积分：<span class="num">{{ datas.total_score }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            总消耗积分：<span class="num">{{ datas.total_cost_score }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            未使用积分：<span class="num">{{ datas.total_remind_score }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            公众号赠送总积分：<span class="num">{{
              datas.total_mp_score
            }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            邀请赠送总积分：<span class="num">{{
              datas.total_invite_score
            }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            兑换总余额：<span class="num">{{ datas.total_redeem_score }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            兑换报价单总积分：<span class="num">{{
              datas.total_redeem_bjd_score
            }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="kqf-card mg10 pd10 mt20"
      v-loading="loading"
      style="min-width: 1100px"
    >
      <el-table
        border
        :data="datas.list"
        height="calc(100vh - 280px)"
        @sort-change="orderby"
      >
        <el-table-column label="ID" width="80" prop="id"></el-table-column>
        <el-table-column label="用户信息" width="350">
          <template slot-scope="scope">
            <div class="flex">
              <div style="margin-left: 10px">
                <p class="text-over">
                  微信昵称：{{ scope.row.hasUsers.nickname }}
                </p>
                <p class="text-over">
                  openid：{{ scope.row.hasUsers.open_id }}
                </p>
                <el-link
                  v-clipboard:success="copySuccess"
                  v-clipboard:copy="scope.row.hasUsers.mobile"
                  type="primary"
                  :underline="false"
                  >手机号：{{ scope.row.hasUsers.mobile }}
                </el-link>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="流水类型"
          prop="flow_type_mean"
        ></el-table-column>
        <el-table-column
          label="支出/收入类型"
          prop="type_mean"
        ></el-table-column>
        <el-table-column label="支出">
          <template slot-scope="scope">
            <div>{{ scope.row.income }}</div>
          </template>
        </el-table-column>
        <el-table-column label="收入">
          <template slot-scope="scope">
            <div>{{ scope.row.expense }}</div>
          </template>
        </el-table-column>
        <el-table-column label="剩余积分" prop="after_score"></el-table-column>
        <el-table-column label="兑换结果" prop="remark"></el-table-column>
        <el-table-column
          label="流水时间"
          prop="created_at"
          width="250"
          sortable
        ></el-table-column>
      </el-table>
      <div class="flex center mt10">
        <div>
          <el-pagination
            @current-change="getList"
            :current-page="search.page"
            background
            :page-size="datas.limit"
            layout="total, prev, pager, next"
            :total="datas.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scoreFlowIndex } from "@/request/api/operation/operation";

export default {
  data() {
    return {
      datas: [],
      search: this.getSearch(),
      //编辑信息
      editloading: false,
      editdialog: false,
      editdata: {
        uid: 0,
        pay_money: ""
      },
      loading: false
    };
  },
  created() {
    this.getList(1);
  },
  methods: {
    getSearch() {
      return {
        flow_type: 0,
        type: 0,
        keyword: "",
        page: 1,
        create_time: [],
        sort: ""
      };
    },
    getList(page) {
      this.search.page = page;
      this.loading = true;
      scoreFlowIndex({
        page: page,
        keyword: this.search.keyword,
        flow_type: this.search.flow_type,
        type: this.search.type,
        create_time: this.search.create_time,
        sort: this.search.sort
      })
        .then(res => {
          this.datas = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    refresh() {
      this.search = this.getSearch();
      this.getList(1);
    },
    // 复制
    copySuccess() {
      this.$message.success("复制成功");
    },
    orderby(e) {
      if (e.order != null) {
        let order = e.order == "descending" ? "desc" : "asc";
        this.search.sort = e.prop + "_" + order;
      } else {
        this.search.sort = "";
      }
      this.getList(1);
    }
  }
};
</script>
<style scoped>
.allMoney {
  margin-left: 20px;
}
.allMoney .num {
  font-size: 15px;
  color: #ff5646;
}
</style>
